<template>
	<div
		:class="['list-columns', disabled && 'is-disabled']"
		data-testid="list-columns"
		v-maxHeight="offset"
		ref="listColumnsContainer"
	>
		<div
			class="list-columns__item"
			v-for="item in listItems"
			:key="item[keyProp]"
		>
			<slot name="body" v-bind:item="item"></slot>
		</div>
	</div>
</template>

<script>
import maxHeightMixin from '@/mixins/max-height-mixin';

export default {
	name: 'ListColumns',
	mixins: [maxHeightMixin],
	props: {
		listItems: {
			type: Array,
			default: () => []
		},
		keyProp: {
			type: [String, Number],
			default: 'id'
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		this.$emit('mounted', this.$refs);
	}
};
</script>

<style lang="scss" scoped>
@include scrollbar('borderless');

.list-columns {
	display: grid;
	grid-template-columns: 1fr;
	gap: $gutter-xl;
	overflow: auto;

	@include mq($from: md-l) {
		grid-template-columns: 1fr 1fr;
	}
}
</style>
